import { formatUnits } from 'viem/utils';

/**
 * 代币规则：
 * 最多保留小数点后9位，只展示到最后一个非零数字位。当整数位超过5位，小数后位数逐渐减少。整数为超过15位时，使用科学计数法，小数点后两位
 */
export const formatTokenAmount = (value: bigint | number | `0x${string}`, decimal: number, decimalPlaces = 9) => {
  if (!value) return '0';
  if (typeof value === 'string' || typeof value === 'number') {
    value = BigInt(value);
  }
  let result = formatUnits(value, decimal);

  const [integerPart, decimalPart] = result.split('.');
  if (decimalPlaces >= 5 && integerPart === '0' && decimalPart?.startsWith(''.padEnd(decimalPlaces, '0'))) {
    return '<0.'.padEnd(decimalPlaces + 3 - 1, '0') + '1';
  }
  result = formatStringNumber(result, decimalPlaces);
  return result;
};

function formatStringNumber(num: string, n: number): string {
  let [integerPart, decimalPart] = num.split('.');

  if (!decimalPart) {
    return integerPart as string;
  }

  decimalPart = decimalPart.slice(0, n);
  decimalPart = decimalPart.replace(/0+$/, '');

  if (decimalPart === '') {
    return integerPart as string;
  }

  return `${integerPart}.${decimalPart}`;
}
